<template>
    <div style=" font-size: 12px;">距结束<span>{{ count }}</span></div>
</template>
<script>
export default {
    data() {
        return {
            count: '10时15分00秒', //倒计时
            seconds: 36900 // 10小时的秒数
        }
    },
    mounted() {
        this.Time() //调用定时器
    },
    methods: {
        // 天 时 分 秒 格式化函数
        countDown() {
            // let d = parseInt(this.seconds / (24 * 60 * 60))
            // d = d < 10 ? "0" + d : d
            let h = parseInt(this.seconds / (60 * 60) % 24);
            h = h < 10 ? "0" + h : h
            let m = parseInt(this.seconds / 60 % 60);
            m = m < 10 ? "0" + m : m
            let s = parseInt(this.seconds % 60);
            s = s < 10 ? "0" + s : s
            this.count = h + '时' + m + '分' + s + '秒'
        },
        //定时器没过1秒参数减1
        Time() {
            setInterval(() => {
                this.seconds -= 1
                this.countDown()
            }, 1000)
        },
    }

}
</script>
<style></style>